import React from "react";
import { useTranslation } from "react-i18next";
import AppModal from "components/ui/AppModal";
import AppSearchInput from "components/ui/AppSearchInput";
import ModifiersTable from "./ModifiersTable";
import AppButton from "components/ui/AppButton";
import CreateModifer from "features/Modifier/CreateModifier";

const AttachModifierModal = ({
  open,
  onClose = () => {},
  setModal = () => {},
  title = "Attach Modifier",
  subtitle = "Attach Modifier to the group",
  attachButtonText = "Attach Modifiers",
  addNewModifierButtonText = "Add New Modifier",
  modifiers,
  checkedRows,
  toBeUnLinkModifiers = [],
  setToBeUnLinkModifiers = () => {},
  onAttachModifiers = () => {},
  onAddNewModifierSuccess = () => {},
}) => {
  const { t } = useTranslation();

  const [selectedModifiers, setSelectedModifiers] = React.useState([]);
  const [openAddNewModifierModal, setOpenAddNewModifierModal] =
    React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredModifiers = React.useMemo(() => {
    const term = searchTerm?.toLowerCase()?.trim();
    if (!term) return modifiers;
    return modifiers?.filter((modifier) =>
      modifier?.baseLanguage?.name?.toLowerCase()?.includes(term)
    );
  }, [modifiers, searchTerm]);

    const handleClose = () => {
      setSelectedModifiers([]);
      setSearchTerm("");
      onClose();
    }
  const handleAttachModifiers = () => {
    onAttachModifiers(selectedModifiers);
    handleClose();
  };
  React.useEffect(() => {
    if (checkedRows?.length > 0) {
      setSelectedModifiers(checkedRows);
    }
  }, [checkedRows]);

  return (
    <>
      <AppModal
        title={title}
        open={open}
        onClose={handleClose}
        footer={
          <div className="flex justify-end gap-3">
            <AppButton
              size="sm"
              variant="primaryOutline"
              onClick={() => {
                setOpenAddNewModifierModal(true);
                setModal(false);
              }}
            >
              {t(addNewModifierButtonText)}
            </AppButton>
            <AppButton
              size="sm"
              disabled={selectedModifiers?.length <= 0}
              variant="primary"
              onClick={() => handleAttachModifiers()}
            >
              {t(attachButtonText)}
            </AppButton>
          </div>
        }
      >
        <div className="mb-3">
          <AppSearchInput
            placeholder={t("Search by name")}
            value={searchTerm}
            onInput={(event) => setSearchTerm(event.target.value)}
          />
        </div>
        <ModifiersTable
          modifiers={filteredModifiers}
          selectedModifiers={selectedModifiers}
          setSelectedModifiers={setSelectedModifiers}
          // setData={setData}
          // setViewGroup={setViewGroup}
          showAttachButton={true}
          showActionButton={false}
          toBeUnLinkModifiers={toBeUnLinkModifiers}
          setToBeUnLinkModifiers={setToBeUnLinkModifiers}
        />
      </AppModal>
      <CreateModifer
        open={openAddNewModifierModal}
        as="modal"
        title={t("Add New Customization")}
        onClose={() => {
          setOpenAddNewModifierModal(false);
          setModal(true);
        }}
        onSuccess={(newModifier) => {
          onAddNewModifierSuccess(newModifier);
          setOpenAddNewModifierModal(false);
          setModal(true);
        }}
      />
    </>
  );
};

export default AttachModifierModal;
